import { render, staticRenderFns } from "./KCrud.vue?vue&type=template&id=c9110414&"
import script from "./KCrud.vue?vue&type=script&lang=js&"
export * from "./KCrud.vue?vue&type=script&lang=js&"
import style0 from "./KCrud.vue?vue&type=style&index=0&id=c9110414&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports